import {Observable, Subscriber} from "rxjs";

export class VarSubject<T> extends Observable<T>{
	public constructor(
		private _value:T,
	){
		super(subscriber=>{
			this.subscribers.push(subscriber);
			subscriber.next(this.value);
			return ()=>{
				const i=this.subscribers.indexOf(subscriber);
				if(i>=0)
					this.subscribers.splice(i,1);
				if(this.subscribers.length===0)
					this.onLastUnsubscribed();
			};
		});
	}

	private subscribers:Subscriber<T>[]=[];
	public readonly completeThis=true;

	public get value(){
		return this._value;
	}

	public set value(v){
		if(this._value!==v)
			this.next(v);
	}

	protected onLastUnsubscribed(){
	}

	public next(v:T){
		this._value=v;
		for(const subscriber of this.subscribers)
			subscriber.next(v);
	}

	public complete(){
		for(const subscriber of this.subscribers)
			subscriber.complete();
		this.subscribers=[];
		this.onLastUnsubscribed();
	}

	public asObservable():Observable<T>{
		return new Observable(subscriber=>this.subscribe({
			next: v=>subscriber.next(v),
			complete: ()=>subscriber.complete(),
			error: r=>subscriber.error(r),
		}));
	}
}
